<style>
.zoezi-collection-receipt .v-btn__content {
  max-width: 100%;
}
.zoezi-collection-receipt .v-btn__content span {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>

<template>
    <div v-on="events">
        <component-wrapper :config="component" style="max-width: 100%;" />
    </div>
</template>

<script>
import components from '../component.js'
import {downloadFile, isExpoApp} from '../util.js'
export default {
    name: 'zoezi-collection-receipt',

    zoezi: {
        title: 'Collection receipt',
        icon: 'mdi-receipt'
    },

    props: {
        component: {
            title: 'Component',
            type: Object,
            fulltype: 'component',
            default: () => components.makeEmptyConfig({component: 'zoezi-button', props: {text: window.$translate('Fetch annual collection receipt')}})
        },
        cards: {}
    },

    computed: {
        events() {
            if (!this.$root.edit) {
                return {
                    click: () => {
                        this.getReceipt();
                    }
                }
            }

            return {};
        }
    },
    methods: {
        getReceipt() {
            let cards = this.cards || this.$store.state.cards;
            if (!cards.length) {
                console.log('No cards')
                return;
            }

            const year = Date.today().getFullYear();
            let args = {
                id: cards.map(card => card.id).join(','),
                fromDate: `${year}-01-01`,
                toDate: `${year}-12-31`,
            };
            let filename = this.$translate('Collection receipt') + '.pdf';

            if (isExpoApp()) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'openFile', data: { api: {url: 'current', path: '/api/memberapi/trainingcard/receipt/get', args}, type: 'pdf' } }));
            } else {
                this.gettingReceipt = true;
                this.$api.get('/api/memberapi/trainingcard/receipt/get', args, {blob: true}).then(x => {
                    downloadFile({filename, blob: x, type: 'application/pdf'});
                    this.gettingReceipt = false;
                })
            }
        }
    }
  }
</script>
